/** Till (brand + mall) remembered per device in localStorage. */

export interface TillSelection {
  tillId: string;
  brandId: string;
  mallId: string;
}

const TILL_KEY = "gp.scanner.till";
const DEVICE_KEY = "gp.scanner.deviceId";

/** Stable random id of this browser, so two tablets at one restaurant are distinct tills. */
function deviceId(): string {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = crypto.randomUUID().slice(0, 8);
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

export function loadTill(): TillSelection | null {
  const raw = localStorage.getItem(TILL_KEY);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<TillSelection>;
    if (typeof value.tillId === "string" && typeof value.brandId === "string" && typeof value.mallId === "string") {
      return { tillId: value.tillId, brandId: value.brandId, mallId: value.mallId };
    }
  } catch {
    // Corrupt entry: fall through and ask again.
  }
  localStorage.removeItem(TILL_KEY);
  return null;
}

export function saveTill(brandId: string, mallId: string): TillSelection {
  const till = { tillId: `${mallId}:${brandId}:${deviceId()}`, brandId, mallId };
  localStorage.setItem(TILL_KEY, JSON.stringify(till));
  return till;
}

export function clearTill(): void {
  localStorage.removeItem(TILL_KEY);
}
